import React from 'react';
import ReactOnRails from 'react-on-rails';
import {getRelatedNumbers} from './lib/basic-algebra.js';
import AlgebraProblemDisplay from './algebra_problem_display.js';
import EquationAnswerEntry from './equation_answer_entry.js';
import EquationSelect from './equation_select.js';
import EquationAnswerFeedback from './equation_answer_feedback.js';
import {displayEquation} from './lib/basic-algebra.js';

export default class Algebra extends React.Component {

  constructor(props) {
    super(props);

    const currentProblem = getRelatedNumbers('addition');
    const currentEquation = displayEquation(currentProblem, 'addition');

    this.state = {
      selectedChoice: 'addition',
      currentProblem: currentProblem,
      currentEquation: currentEquation,
      currentAnswer: '',
      equationAttempted : false,
      equationAnswerCorrect : false
    };

    this.createNewEquation = this.createNewEquation.bind(this);
    this.updateEquationAnswerStatus = this.updateEquationAnswerStatus.bind(this);
  }

  createNewEquation(selected){
    selected = selected || this.state.selectedChoice;

    const currentProblem = getRelatedNumbers(selected);
    const currentEquation = displayEquation(currentProblem, selected);

    this.setState({
      selectedChoice: selected,
      currentProblem: currentProblem,
      currentEquation: currentEquation,
      currentAnswer: '',
      equationAttempted: false,
      equationAnswerCorrect: false
    });
  }

  updateEquationAnswerStatus(isAnswerCorrect){
    this.setState({
      equationAnswerCorrect: isAnswerCorrect,
      equationAttempted: true
    });
  }

  updateAnswer(newAnswer) {
    this.setState({currentAnswer: newAnswer});
  }

  render(){
    return (
      <div>
        <AlgebraProblemDisplay
          currentEquation={this.state.currentEquation} />
        <EquationAnswerFeedback
          equationAnswerCorrect={this.state.equationAnswerCorrect}
          visible={this.state.equationAttempted} />
        <EquationAnswerEntry
          currentProblem={this.state.currentProblem}
          currentAnswer={this.state.currentAnswer}
          updateAnswer={this.updateAnswer.bind(this)}
          createNewEquation={this.createNewEquation}
          updateEquationAnswerStatus={this.updateEquationAnswerStatus} />
        <hr className="inequality-hr" />
        <EquationSelect
          updateEquationSelectChoice={this.createNewEquation} />
      </div>
    );
  }
}

ReactOnRails.register({ Algebra });



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/algebra/component.js
 **/